module.exports = __webpack_public_path__ + "static/img/_hjcg.2be3ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_hjcg.png
// module id = Rt2c
// module chunks = 96